var ControlsStack = require( 'kitbuilder-views/controls-stack' );

module.exports = ControlsStack.extend( {
	id: 'kitbuilder-panel-page-settings',

	template: '#tmpl-kitbuilder-panel-page-settings',

	childViewContainer: '#kitbuilder-panel-page-settings-controls',

	childViewOptions: function() {
		return {
			elementSettingsModel: this.model
		};
	},

	initialize: function() {
		this.model = kitbuilder.pageSettings.model;

		this.collection = new Backbone.Collection( _.values( this.model.controls ) );
	}
} );
